import store from './store';
import 'flag-icon-css/css/flag-icon.min.css';
import Vue from 'vue';

let countryPlugin = {
    waitCountry() {
        if (!this.store.state.loaded) {
            return new Promise((resolve, reject) => {
                resolve(this.getCountryID());
            });
        } else {
            return this.loadingPromise.then(() => {
                return this.getCountryID();
            });
        }
    },
    getCountry() {
        return this.store.getters.getCountry;
    },
    getCountryObject() {
        return this.getCountryBy('id', this.getCountryID());
    },
    getCountryID() {
        return this.store.getters.getCountryID;
    },
    getCountryNameBy(key, value) {
        return this.store.getters.getCountryNameBy(key, value);
    },
    getCountryBy(key, value) {
        return this.store.getters.getCountryBy(key, value);
    },
    getCountries() {
        return this.store.state.countries;
    },
    setCountry(value) {
        this.store.commit('setCountry', value);

        Vue.$currency.setSelected(this.getCountryCurrency(value));
    },
    getCountryCurrency(countryCode) {
        return this.getCountryBy('iso_2', countryCode) ? this.getCountryBy('iso_2', countryCode).currency : null;
    },
    loadingPromise: null,
};

export default {
    install(Vue) {
        countryPlugin.store = store;

        countryPlugin.loadingPromise = store.dispatch('loadCountries').then(() => {
            return Vue.$countryDetectService.detectCountry().then(customerCountry => {
                let selectedCountry = '';
                if (
                    Vue.localStorage.get('selectedCountry') &&
                    countryPlugin.store.state.countries[Vue.localStorage.get('selectedCountry')]
                ) {
                    selectedCountry = Vue.localStorage.get('selectedCountry');
                } else if (customerCountry && countryPlugin.store.state.countries[customerCountry]) {
                    selectedCountry = customerCountry;
                } else {
                    for (let country of Object.values(countryPlugin.store.state.countries)) {
                        if (country.isFavorite) {
                            selectedCountry = country.iso_2;
                        }
                    }
                }

                countryPlugin.store.commit('setCountry', selectedCountry);
                return selectedCountry;
            });
        });

        Vue.$country = countryPlugin;
        Vue.prototype.$country = countryPlugin;
    },
};
